import { render, staticRenderFns } from "./CurrentMonthOperationalCardsStatistics.vue?vue&type=template&id=2964cb8f&scoped=true&"
import script from "./CurrentMonthOperationalCardsStatistics.vue?vue&type=script&lang=js&"
export * from "./CurrentMonthOperationalCardsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CurrentMonthOperationalCardsStatistics.vue?vue&type=style&index=0&id=2964cb8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964cb8f",
  null
  
)

export default component.exports